import styled from '@emotion/styled';
import { shouldForwardProp } from '@/utils/style.utils';

const Wrapper = styled('div', { shouldForwardProp })<{ $isDesktop: boolean }>`
  margin-bottom: ${({ $isDesktop }) => ($isDesktop ? '16px' : '0px')};
`;
const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export default {
  Wrapper,
  ImageWrapper,
};
